module.exports = __webpack_public_path__ + "static/img/6.de926a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/app/6.png
// module id = OPRV
// module chunks = 1